export default __webpack_public_path__ + "static/media/tutorial2-4.82460830.png";